/** Shared by the GIS button (client) and /api/gsi/callback (server). */
export const GSI_RETURN_COOKIE = "yt_gsi_return";
export const GSI_CREDENTIAL_COOKIE = "yt_gsi_credential";
export const GSI_CALLBACK_PATH = "/api/gsi/callback";

/** Same-site return path only: a "/" path, no scheme, no "//" or backslash tricks, not the callback itself. */
export function safeGsiReturnPath(raw: string | undefined | null): string {
  let p = raw ?? "";
  try { p = decodeURIComponent(p); } catch { return "/"; }
  if (!p.startsWith("/") || p.startsWith("//") || p.includes("\\") || /[\r\n]/.test(p)) return "/";
  if (p.startsWith("/api/")) return "/";
  return p.slice(0, 512);
}

/** Popup mode breaks on phones (popup opens as a tab, loses window.opener) and in the installed app. */
/**
 * Hosts whose https://<host>/api/gsi/callback is an Authorized redirect URI on the Google OAuth client.
 * Redirect mode on any other host fails at Google with Error 400 redirect_uri_mismatch, so those stay on popup.
 * Add a host here (or in NEXT_PUBLIC_GSI_REDIRECT_HOSTS, comma separated) only after its URI is in the console.
 */
const GSI_REDIRECT_HOSTS = ["studio.yatishara.com"];
export function gsiRedirectAllowed(host: string): boolean {
  const extra = (process.env.NEXT_PUBLIC_GSI_REDIRECT_HOSTS ?? "").split(",").map((h) => h.trim().toLowerCase()).filter(Boolean);
  return [...GSI_REDIRECT_HOSTS, ...extra].includes(host.toLowerCase());
}

export function gsiShouldRedirect(): boolean {
  if (typeof window === "undefined") return false;
  if (!gsiRedirectAllowed(window.location.hostname)) return false;
  const standalone = window.matchMedia?.("(display-mode: standalone)").matches || (navigator as { standalone?: boolean }).standalone === true;
  const mobile = /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent) || (navigator.maxTouchPoints > 1 && /Macintosh/.test(navigator.userAgent));
  return Boolean(standalone || mobile);
}
